import { AdSet } from './ad-set';
import { NpiDetectorsConfig, NpiSourceEnum, SwoopIntegrationTypeEnum } from '../dto/recs.dto';

export class AdSetSettings {
  private adSet?: AdSet;

  private readonly swoopId?: string | null;

  private readonly swoopIntegrationType?: SwoopIntegrationTypeEnum | null;

  private readonly swoopScriptUrl?: string | null;

  private readonly userMetricsScriptUrl?: string | null;

  private readonly npiDetectionEnabled: boolean = false;

  private readonly npiSources: NpiSourceEnum[] = [];

  private readonly npiDetectors?: Record<NpiSourceEnum, NpiDetectorsConfig> | null;

  public getAdSet (): AdSet | null {
    return this.adSet ?? null;
  }

  public setAdSet (adSet?: AdSet): this {
    this.adSet = adSet;
    return this;
  }

  public isNpiDetectionEnabled (): boolean {
    return this.npiDetectionEnabled ?? false;
  }

  public getSwoopId (): string | null {
    return this.swoopId ?? null;
  }

  public getSwoopIntegrationType (): SwoopIntegrationTypeEnum | null {
    return this.swoopIntegrationType ?? SwoopIntegrationTypeEnum.NONE;
  }

  public getSwoopScriptUrl (): string | null {
    return this.swoopScriptUrl ?? null;
  }

  public getUserMetricsScriptUrl (): string | null {
    return this.userMetricsScriptUrl ?? null;
  }

  public getNpiSources (): NpiSourceEnum[] {
    return this.npiSources;
  }

  public getNpiDetectors (): typeof this.npiDetectors | null {
    return this.npiDetectors ?? null;
  }
}
